export default "__VITE_ASSET__CroA07FE__"